import { auth } from './firebase';
import { writable, Writable } from '../libs/store';
import { onNextChange } from '../libs/helpers';
import globals from '../globals';

export interface User {
  uid: string;
  name: string;
}

interface UserStore extends Writable<User> {
  setName(name: string): Promise<void>;
}

export const user = createUserStore();

(window as any).user = user;
let newUserName = '';

export async function getUser() {
  let theUser = user.get();
  // wait until autstatechanged has a chance to run
  if (theUser === undefined) theUser = await new Promise(resolve => onNextChange(user, resolve));
  if (!theUser) {
    const displayName = (await globals.prompt('Name', 'What is the name you would like to be known by?', { placeholder: 'Name...' })).trim();
    if (!displayName) return globals.alert('Name Required', 'You need to enter a name to use this service.');
    globals.inform('info', 'Saving...', 'Please wait.');
    newUserName = displayName;
    const account = (await auth.signInAnonymously()).user;
    await account.updateProfile({ displayName });
    globals.inform('success', 'Account created!', 'You may now create/participate in group sprints.');
    newUserName = '';
  }
  return user.get();
}

auth.onAuthStateChanged(async account => {
  if (!account) user.set(null);
  else user.set({ uid: account.uid, name: newUserName || account.displayName });
});


function createUserStore(): UserStore {
  const { get, set, update, subscribe } = writable<User>(undefined);

  async function setName(name: string) {
    if (!auth.currentUser) return;
    await auth.currentUser.updateProfile({ displayName: name });
    set({ uid: auth.currentUser.uid, name });
  }

  return {
    setName,
    get, set, update, subscribe
  };
}
